import { render, staticRenderFns } from "./SubtitlesPresetsBottomSheet.vue?vue&type=template&id=15ae6bbc&scoped=true"
import script from "./SubtitlesPresetsBottomSheet.vue?vue&type=script&lang=js"
export * from "./SubtitlesPresetsBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./SubtitlesPresetsBottomSheet.vue?vue&type=style&index=0&id=15ae6bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ae6bbc",
  null
  
)

export default component.exports